import React from "react";
import PropTypes from "prop-types";
import {useTranslation} from "react-i18next";
import {RiArrowLeftLine} from "react-icons/ri";
import {Backdrop, Card, BackBtn, Title, Hint, Area, Count, Warn, Actions, CancelBtn, AddBtn} from "./styles";

// parseNumbers: quebra linhas, tira não-dígitos, remove vazios, dedup. Exportada pra teste.
export const parseNumbers = (text) => {
    const seen = new Set();
    const out = [];
    (text || "").split(/\r?\n/).forEach((line) => {
        const n = line.replace(/\D/g, "");
        if (n && !seen.has(n)) {
            seen.add(n);
            out.push(n);
        }
    });
    return out;
};

const AddMemberModal = ({open, onCancel, onConfirm, onBack, available}) => {
    const {t} = useTranslation();
    const [text, setText] = React.useState("");
    const [submitting, setSubmitting] = React.useState(false);

    React.useEffect(() => {
        if (open) {
            setText("");
            setSubmitting(false);
        }
    }, [open]);

    if (!open) return null;

    const numbers = parseNumbers(text);
    // Guarda proativa de capacidade: além do backend (que pula excedentes e reporta skipped_capacity),
    // a UI já impede submeter acima das vagas disponíveis do grupo.
    const overflow = typeof available === "number" && numbers.length > available;
    const confirm = async () => {
        if (!numbers.length || submitting || overflow) return;
        setSubmitting(true);
        await onConfirm(numbers);
        // o pai fecha o modal; se não fechar, libera o botão
        setSubmitting(false);
    };

    return (
        <Backdrop onClick={onCancel}>
            <Card onClick={(e) => e.stopPropagation()}>
                {onBack && (
                    <BackBtn type="button" onClick={onBack}><RiArrowLeftLine/> {t("words.back")}</BackBtn>
                )}
                <Title>{t("words.add_member_title")}</Title>
                <Hint>{t("words.add_member_hint")}</Hint>
                <Area
                    value={text}
                    onChange={(e) => setText(e.target.value)}
                    placeholder={t("words.add_member_placeholder")}
                    aria-label={t("words.add_member_title")}
                />
                <Count>{numbers.length}{typeof available === "number" ? ` / ${available}` : ""}</Count>
                {overflow && <Hint>{t("words.available_seats")}: {available}</Hint>}
                <Warn>{t("words.add_member_anti_ban_note")}</Warn>
                <Actions>
                    <CancelBtn type="button" onClick={onCancel}>{t("words.cancel")}</CancelBtn>
                    <AddBtn type="button" disabled={!numbers.length || submitting || overflow} onClick={confirm}>
                        {t("words.add_member")}
                    </AddBtn>
                </Actions>
            </Card>
        </Backdrop>
    );
};

AddMemberModal.propTypes = {
    open: PropTypes.bool,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
    onBack: PropTypes.func,
    available: PropTypes.number,
};

export default AddMemberModal;
